import * as React from "react";
import * as routes from "../../constants/routes";
import {auth, db} from "../../firebase";
import {Form, Button} from 'semantic-ui-react';

interface InterfaceProps {
    email?: string;
    error?: any;
    history?: any;
    password?: string;
}

interface InterfaceState {
    email: string;
    error: any;
    password: string;
}

export class SignInForm extends React.Component<InterfaceProps,
    InterfaceState> {
    private static INITIAL_STATE = {
        email: "",
        error: null,
        password: "",
    };

    private static propKey(propertyName: string, value: any): object {
        return {[propertyName]: value};
    }

    constructor(props: InterfaceProps) {
        super(props);

        this.state = {...SignInForm.INITIAL_STATE};
    }

    public onSubmit = (event: any) => {
        const {email, password} = this.state;

        const {history} = this.props;

        auth
            .doSignInWithEmailAndPassword(email, password)
            .then((credential) => {
                console.log(credential.user)
                db.doGetUserById(credential.user.uid).then(snapshot => {
                    const user = snapshot.val();
                    if (user && user.isAdmin) {
                        this.setState(() => ({...SignInForm.INITIAL_STATE}));
                        history.push(routes.HOME);
                    } else {
                        const error = {
                            message: "You are not Admin"
                        }
                        this.setState(SignInForm.propKey("error", error));
                    }
                });
            })
            .catch(error => {
                this.setState(SignInForm.propKey("error", error));
            });
        event.preventDefault();
    };

    public render() {
        const {email, password, error} = this.state;

        const isInvalid = password === "" || email === "";

        return (
            <Form onSubmit={event => this.onSubmit(event)}>

                <input
                    value={email}
                    onChange={event => this.setStateWithEvent(event, "email")}
                    type="text"
                    placeholder="Email Address"
                />

                <input
                    value={password}
                    onChange={event => this.setStateWithEvent(event, "password")}
                    type="password"
                    placeholder="Password"
                />

                <Button disabled={isInvalid} style={{marginTop: "10px"}} type="submit" primary>
                    Sign In
                </Button>
                {error && <p>{error.message}</p>}
            </Form>
        );
    }

    private setStateWithEvent(event: any, columnType: string): void {
        this.setState(SignInForm.propKey(columnType, (event.target as any).value));
    }
}



// WEBPACK FOOTER //
// ./src/pages/SignIn/SignInForm.tsx